
import { FieldType } from '@/helpers/types';
import { defineComponent } from 'vue';

const __default__ = defineComponent({
  props: {
    field: {
      type: Object
    },
    emailSummary: {
      type: String
    },
    depth: {
      type: Number
    }
  },
  data() {
    return {
      selectedAnswerValue: '',
      emailSummaryValue: ''
    };
  },
  computed: {
    isSelectNode() {
      return this.field.fieldType === FieldType.SELECT;
    },
    isAnswerNode() {
      return this.field.fieldType === FieldType.ANSWER;
    },
    getListStyleType() {
      const listItemTypes = ['disc', 'circle', 'square'];
      return listItemTypes[this.depth % listItemTypes.length];
    },
    getFormIndentation() {
      // Due to width limitations in the ZD app, we stop indenting after 2 levels
      return this.depth <= 2 ? '15px' : '0px';
    }
  },
  methods: {
    getValueFromEmailBody() {
      if (!this.emailSummary) {
        this.emailSummaryValue = '';
        return;
      }
      const summaryLines = this.emailSummary.split('\n');
      const matchingLine = summaryLines.find((part) => part.includes(this.field.fieldLabel));
      if (!matchingLine) {
        this.emailSummaryValue = 'Not provided';
        return;
      }
      const value = matchingLine.split(`${this.field.fieldLabel}: `)[1];
      this.emailSummaryValue = value || 'Not provided';
    }
  },
  watch: {
    emailSummary: {
      immediate: true,
      handler() {
        this.getValueFromEmailBody();
      }
    }
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "668b2a10": (_ctx.getFormIndentation),
  "8489f240": (_ctx.getListStyleType)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__